import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button, Form } from "react-bootstrap";
import appConstants from "../constants/appConstants";
import Layout from "../components/Layout";
import { FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const getAuthToken = () => localStorage.getItem("authToken");

const Payment = () => {
    const navigate = useNavigate();
    const [newPayment, setNewPayment] = useState({
        from_account: "",
        to_account: "",
        from_account_id: "",
        to_account_id: "",
        amount: "",
        date: new Date().toISOString().split('T')[0],
        description: ""
    });
    const [payments, setPayments] = useState([]);
    const [accounts, setAccounts] = useState([]);
    const [cashAccounts, setCashAccounts] = useState([]);
    
    useEffect(() => {
        fetchAccounts();
        fetchCashAccounts();
    }, []);

    const fetchAccounts = async () => {
        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");
        try {
            const response = await axios.get(`${appConstants.API_ROOT_URL}get-accounts`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setAccounts(response.data.data);
        } catch (error) {
            console.error("Error fetching accounts:", error);
        }
    };

    const fetchCashAccounts = async () => {
        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");
    
        try {
            const response = await axios.post(
                `${appConstants.API_ROOT_URL}get-accounts`,
                { account_type_ids: [9,10] },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
    
            if (response.data.data) {
                setCashAccounts(response.data.data);
            } else {
                console.error("Failed to fetch cash accounts", response.data);
                alert("Failed to fetch cash accounts.");
            }
        } catch (error) {
            console.error("Error fetching accounts:", error);
            alert("An error occurred while fetching cash accounts.");
        }
    };

    const addPayment = async () => {
        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");
    
        try {
            const response = await axios.post(`${appConstants.API_ROOT_URL}create-payment`, newPayment, {
                headers: { Authorization: `Bearer ${token}` }
            });
    
            if (response.data.status === "success") {
                alert(`Payment added successfully! Payment Number: ${response.data.payment_number}`);
                setNewPayment({ from_account_id: "", from_account: "", to_account_id: "", to_account: "", amount: "", date: newPayment.date, description: "" });
    
            } else {
                alert(`Error: ${response.data.message}`);
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || "An unexpected error occurred";
            alert(`Error adding payment: ${errorMessage}`);
            console.error(error);
        }
    };

    return (
        <Layout>
            <div className="p-3 bg-light">
                <h5>Create Payment</h5>
                <Form>
                    <Form.Group className="mb-2">
                        <Form.Label>Date</Form.Label>
                        <Form.Control type="date" value={newPayment.date} 
                            onChange={(e) => setNewPayment({ ...newPayment, date: e.target.value })} />
                    </Form.Group>

                    <Form.Group className="mb-2">
                        <Form.Label>From Account</Form.Label>
                        <Form.Control 
                            list="cash-accounts" 
                            value={newPayment.from_account}
                            onChange={(e) => {
                                const selectedAccount = cashAccounts.find(acc => acc.name === e.target.value);
                                setNewPayment({
                                    ...newPayment,
                                    from_account_id: selectedAccount?.id || "",
                                    from_account: e.target.value
                                });
                            }}
                        />
                        <datalist id="cash-accounts">
                            {cashAccounts.map(account => (
                                <option key={account.id} value={account.name} data-id={account.id}>{account.name}</option>
                            ))}
                        </datalist>
                    </Form.Group>

                    <Form.Group className="mb-2">
                        <Form.Label>To Account</Form.Label>
                        <Form.Control 
                            list="accounts" 
                            value={newPayment.to_account}
                            onChange={(e) => {
                                const selectedAccount = accounts.find(acc => acc.name === e.target.value);
                                setNewPayment({
                                    ...newPayment,
                                    to_account_id: selectedAccount?.id || "",
                                    to_account: e.target.value
                                });
                            }}
                        />
                        <datalist id="accounts">
                            {accounts.map(account => (
                                <option key={account.id} value={account.name} data-id={account.id}>{account.name}</option>
                            ))}
                        </datalist>
                    </Form.Group>

                    <Form.Group className="mb-2">
                        <Form.Label>Amount</Form.Label>
                        <Form.Control type="number" value={newPayment.amount} 
                            onChange={(e) => setNewPayment({ ...newPayment, amount: e.target.value })} />
                    </Form.Group>
                    
                    <Form.Group className="mb-2">
                        <Form.Label>Description</Form.Label>
                        <Form.Control type="text" value={newPayment.description} 
                            onChange={(e) => setNewPayment({ ...newPayment, description: e.target.value })} />
                    </Form.Group>
                    
                    <Button variant="primary" onClick={addPayment}>
                        <FaPlus /> Add Payment
                    </Button>
                    <Button 
                        variant="secondary" 
                        className="ms-2" 
                        onClick={() => navigate("/payment-list")}
                    >
                        View Payments
                    </Button>
                </Form>
            </div>
        </Layout>
    );
};

export default Payment;
